import {
  Phone, PhoneIncoming, PhoneOutgoing, PhoneMissed, Target, History, Users,
  Check, Voicemail, FileText, BarChart3, Search, Bell, Settings, Mic,
  Play, Pause, PhoneCall, ArrowLeftRight, Grid3x3, PhoneOff, ChevronRight,
  ChevronDown, Plus, MoreHorizontal, Star, ArrowLeft, ArrowRight, Zap, Clock,
  Tag, Trash2, Pencil, Copy, Expand, X, Flag, Globe, Sun, Moon, Send, User,
  Circle, MessageSquare, Calendar, Headphones, Mail, AlertTriangle, CheckCircle2,
  AlertCircle, Info, Sparkles, Filter, Download, Upload, ExternalLink, Eye,
  EyeOff, Lock, Unlock, ListTree, LayoutGrid, MoveRight, BookOpen, CreditCard,
  ClipboardPaste, TrendingUp, Hash, LogOut, SlidersVertical, Workflow, Monitor,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { CSSProperties } from 'react';

const ICONS: Record<string, LucideIcon> = {
  phone: Phone, phoneIn: PhoneIncoming, phoneOut: PhoneOutgoing, phoneMiss: PhoneMissed,
  target: Target, history: History, users: Users, check: Check, voicemail: Voicemail,
  doc: FileText, chart: BarChart3, search: Search, bell: Bell, settings: Settings,
  mic: Mic, play: Play, pause: Pause, conf: PhoneCall, transfer: ArrowLeftRight,
  keypad: Grid3x3, hang: PhoneOff, chevron: ChevronRight, chevronD: ChevronDown,
  plus: Plus, more: MoreHorizontal, star: Star, arrowL: ArrowLeft, arrowR: ArrowRight,
  bolt: Zap, clock: Clock, tag: Tag, trash: Trash2, edit: Pencil, copy: Copy,
  expand: Expand, close: X, flag: Flag, globe: Globe, sun: Sun, moon: Moon,
  send: Send, user: User, dot: Circle, chat: MessageSquare, calendar: Calendar,
  headphones: Headphones, mail: Mail, warn: AlertTriangle, ok: CheckCircle2,
  danger: AlertCircle, info: Info, ai: Sparkles, filter: Filter,
  download: Download, upload: Upload, link: ExternalLink, eye: Eye, eyeOff: EyeOff,
  lock: Lock, unlock: Unlock, tree: ListTree, grid: LayoutGrid,
  moveRight: MoveRight, book: BookOpen, creditCard: CreditCard, trend: TrendingUp,
  clipboard: ClipboardPaste, hash: Hash, logout: LogOut, sliders: SlidersVertical,
  workflow: Workflow, monitor: Monitor,
};

export type IconName = keyof typeof ICONS;

export interface IconProps {
  name: IconName | string;
  size?: number;
  color?: string;
  className?: string;
  style?: CSSProperties;
  'aria-hidden'?: boolean;
}

export function Icon({ name, size = 16, color, className, style, 'aria-hidden': ariaHidden = true }: IconProps) {
  const Component = ICONS[name as IconName] ?? Circle;

  return (
    <Component
      size={size}
      color={color}
      strokeWidth={1.8}
      className={className}
      style={style}
      aria-hidden={ariaHidden}
    />
  );
}
